var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[(_vm.request)?_c('simple-text',{attrs:{"content":_vm.request.topic.title}}):_vm._e()],1),_c('br'),(_vm.request)?_c('simple-text',{attrs:{"content":_vm.request.subtopic.title}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }